<div class="wrapper">
  <div
    class="contextMenuAnchor"
    [style.left]="assemblyMenuPosition.x"
    [style.top]="assemblyMenuPosition.y"
    [matMenuTriggerFor]="assemblySheetMenu"
    #assemblyMenuTrigger="matMenuTrigger"
  ></div>

  <mat-menu #assemblySheetMenu="matMenu" (closed)="closeAssemblySheetMenu()">
    <button mat-menu-item (click)="handleAssemblySheetMenuAction('local', $event)">
      <mat-icon>receipt_long</mat-icon>
      <span>Сборочный лист</span>
    </button>
    <button mat-menu-item (click)="handleAssemblySheetMenuAction('agent', $event)">
      <mat-icon>alt_route</mat-icon>
      <span>Сборочный лист в другой агент</span>
    </button>
  </mat-menu>

  <mat-card class="headerCard">
    <div class="headerCardContent">
      <div class="titleBlock">
        <div class="eyebrow">Складская корзина</div>
        <h1 class="pageTitle">Корзина</h1>
        <div class="pageSubtitle">Выбрано для действий: {{ passProducts.length }} из {{ cartItemsCount }}</div>
      </div>

      <div class="summaryGroup">
        <div class="summaryChip">
          <mat-icon>inventory_2</mat-icon>
          <div>
            <span>Товаров</span>
            <strong>{{ cartItemsCount }}</strong>
          </div>
        </div>

        <div class="summaryChip">
          <mat-icon>task_alt</mat-icon>
          <div>
            <span>Выбрано</span>
            <strong>{{ passProducts.length }}</strong>
          </div>
        </div>

        <div class="summaryChip summaryChip--accent">
          <mat-icon>payments</mat-icon>
          <div>
            <span>Сумма</span>
            <strong>{{ supportService.formatMoney(cartSum) }}</strong>
          </div>
        </div>
      </div>

      <button mat-stroked-button type="button" class="menuButton" (click)="drawer.toggle()">
        <mat-icon>tune</mat-icon>
        <span>Действия</span>
      </button>
    </div>
  </mat-card>

  <mat-drawer-container class="container" autosize>
    <mat-drawer #drawer class="sidenav" position="end" opened="true" mode="side">
      <div class="sidenavContent">
        <mat-card class="actionCard actionCard--summary">
          <mat-card-header>
            <div mat-card-avatar class="cardAvatar">
              <mat-icon>shopping_cart_checkout</mat-icon>
            </div>
            <mat-card-title>Быстрые действия</mat-card-title>
            <mat-card-subtitle>Создай документ из всей корзины или только из отмеченных товаров</mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="actionCard">
          <mat-card-content class="buttonWrapper">
            <a
              routerLink="/docs/export/create"
              [state]="{
                selected: passProducts
              }"
              mat-flat-button
              color="primary"
              class="actionButton"
            >
              <mat-icon>point_of_sale</mat-icon>
              <span>Создать продажу</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </a>

            <a
              routerLink="/orders/create"
              [state]="{
                selected: passProducts
              }"
              mat-flat-button
              color="primary"
              class="actionButton"
            >
              <mat-icon>assignment</mat-icon>
              <span>Создать заказ</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </a>

            <button
              mat-flat-button
              color="primary"
              class="actionButton"
              (click)="printAssemblySheet()"
              (contextmenu)="openAssemblySheetMenu($event)"
            >
              <mat-icon>fact_check</mat-icon>
              <span>Сборочный лист</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </button>

            <a
              routerLink="/docs/import/create"
              [state]="{
                selected: passProducts
              }"
              mat-flat-button
              color="primary"
              class="actionButton"
            >
              <mat-icon>inventory</mat-icon>
              <span>Создать приход</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </a>

            <a
              routerLink="/docs/buy/create"
              [state]="{
                selected: passProducts
              }"
              mat-flat-button
              color="primary"
              class="actionButton"
            >
              <mat-icon>shopping_bag</mat-icon>
              <span>Создать закупку поставщику</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </a>

            <a
              routerLink="/docs/moving/create"
              [state]="{
                selected: passProducts
              }"
              mat-flat-button
              color="primary"
              class="actionButton"
            >
              <mat-icon>swap_horiz</mat-icon>
              <span>Создать передвижение товара</span>
              <span class="actionCount" *ngIf="selectedCount > 0">{{ selectionCountLabel }}</span>
            </a>

            <button mat-flat-button color="warn" class="actionButton actionButton--warn" (click)="clear()">
              <mat-icon>delete_sweep</mat-icon>
              <span>Очистить</span>
            </button>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-drawer>

    <div class="productsTable">
      <mat-card class="productsCard">
        <mat-card-header>
          <div mat-card-avatar class="cardAvatar cardAvatar--products">
            <mat-icon>inventory_2</mat-icon>
          </div>
          <mat-card-title>Товары в корзине</mat-card-title>
          <mat-card-subtitle>Измени количество и цену, затем создай нужный документ</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content class="productsCardContent">
          <app-product-table
            [productsFormArray]="cart"
            [columnsToDisplay]="columnsToDisplay"
            [selectedProductsFormArray]="selectedProductsFormArray"
            (rowChangeEvent)="rowChangeEvent($event)"
            (removeEvent)="handleRemoveFromCart($event)"
          ></app-product-table>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-drawer-container>
</div>
